import React from "react";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import { Form } from "@ant-design/compatible";
import { Button, Alert } from "antd";

import { renderInput, buttonLayout } from "components/FormItem";
import { requiredText } from "utils/formValidations";

import IconInput from "./IconInput";

const CategoriesForm = ({
  handleSubmit, t, pristine, submitting, error,
}) => (
  <Form onSubmit={handleSubmit}>
    {error && <Alert message={error} type="error" />}
    <Field
      name="name"
      label={t("menu.MenuCategories.Form.Name.Label")}
      placeholder={`${t("menu.MenuCategories.Form.Name.Placeholder")}`}
      component={renderInput}
      validate={requiredText}
    />
    <Field
      name="icon"
      label={t("menu.MenuCategories.Form.Icon.Label")}
      component={IconInput}
      t={t}
    />
    <Form.Item {...buttonLayout}>
      <Button type="primary" htmlType="submit" disabled={pristine || submitting}>
        {t("Save")}
      </Button>
    </Form.Item>
  </Form>
);

CategoriesForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

export default reduxForm({
  form: "menuCategoryForm",
})(CategoriesForm);
